import { Box, BoxProps, Button, ColorOptions, IconButton, ModalDialogNew, ModBox, Spacer, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useIsFocused } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { Dimensions, Platform } from 'react-native'
import FileViewer from 'react-native-file-viewer'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { DownloadFileModal } from '../../comps/DownloadFileModal'
import { DownloadInfo } from '../../comps/DownloadInfo'
import { DateRangeSelector } from '../../comps/Filters/DateRangeSelector'
import { SvgImage } from '../../comps/SvgImage'
import TopTabNavigator from '../../comps/TopTabNavigator'
import { actionMenuStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { getString } from '../../util/languageStrings'
import { DeviceShare, openFileOnDevice } from '../../util/permissions'
import {
  Colors,
  DOWNLOAD_FAILED,
  ENABLE_REPORT_DOWNLOADS_IN_MOBILE,
  FILE_DOWNLOADED,
  hasPermissions,
  logEvent,
} from '../../util/util'
import { PAYMENTS, ReceivedTransactionStats } from '../HomeNew/ReceivedTransactionStats'
import { Downloads } from './Downloads'
import { ReceivedTransactionNative } from './ReceivedTransactionNative'
import { RefundedTransactionNative } from './RefundedTransactionNative'
import { Settled } from './Settled'

const getType: any = {
  0: Routes.TRANSACTIONS,
  1: Routes.SETTLEMENTS,
  2: Routes.REFUNDS,
}

export const Payments = () => {
  const {
    fetchSettlements,
    recievedSelectedDateInfo,
    refundedSelectedDateInfo,
    settledSelectedDateInfo,
    getTransactionsColumn,
    getRefunds,
    getTrxn,
    canExportTransationsReport,
    exportFiles,
    setMessage,
    generateSettlementFile,
    exportStatementDateInfo,
    updateExportStatementDateInfo,
    toastMessage,
    toastResetMessage,
    selectedAppLanguage,
  } = useStores((store) => ({
    fetchSettlements: store.settings.metaData.fetchStatsV3,
    recievedSelectedDateInfo: store.transactions.receivedSelectedDateInfo,
    refundedSelectedDateInfo: store.transactions.refundedSelectedDateInfo,
    getTransactionsColumn: store.transactions.getTransactionsColumnV3,
    getRefunds: store.transactions.getRefundsTxnsV3,
    getTrxn: store.transactions.getTransactionsV3,
    canExportTransationsReport: store.userManagement.canExportTransationsReport(),
    exportFiles: store.transactions.exportFilesTxnV3,
    setMessage: store.response.setMessage,
    generateSettlementFile: store.settlements.generateSettlementFile,
    exportStatementDateInfo: store.transactions.exportStatementDateInfo,
    updateExportStatementDateInfo: store.transactions.updateExportStatementDateInfo,
    settledSelectedDateInfo: store.settlements.selectedDateInfo,
    toastMessage: store?.reports?.getMessage(),
    toastResetMessage: store?.reports?.resetMessage,
    selectedAppLanguage: store.settings.config.selectedAppLanguage,
  }))

  const [fetchTxnColumns, txnColumnHandler] = useLazyApiData(getTransactionsColumn)
  const [fetchRefunds, fetchRefundsHandler] = useLazyApiData(getRefunds)
  const [fetchTxn, fetchTxnHandler] = useLazyApiData(getTrxn)
  const [fetchSettlementsApi, settlementApiHandler] = useLazyApiData(fetchSettlements)
  const [exportFile, { state: exportFileApiState, data: exportFileAPiData }] = useLazyApiData(exportFiles)
  const [generateSettlemFile, { state: generateFileState }] = useLazyApiData(generateSettlementFile)

  const [fetchTxnColumnsOnLoadMore, txnColumnLoadMoreHandler] = useLazyApiData(getTransactionsColumn)
  const [fetchRefundsOnLoadMore, fetchRefundsLoadMoreHandler] = useLazyApiData(getRefunds)
  const [fetchTxnOnLoadMore, fetchTxnLoadMoreHandler] = useLazyApiData(getTrxn)

  const refundApiHandlers = [txnColumnHandler, fetchRefundsHandler]
  const transactionApiHandlers = [txnColumnHandler, fetchTxnHandler]

  const refundApiLoadMoreHandlers = [txnColumnLoadMoreHandler, fetchRefundsLoadMoreHandler]
  const transactionApiLoadMoreHandlers = [txnColumnLoadMoreHandler, fetchTxnLoadMoreHandler]

  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const [dateRangeModalVisible, setDateRangeModalVisible] = useState(false)
  const [showDownloadReportsVisible, setShowDownloadReportsVisible] = useState(false)
  const selectedDateInfo =
    selectedTabIndex === 0
      ? recievedSelectedDateInfo
      : selectedTabIndex === 1
      ? settledSelectedDateInfo
      : refundedSelectedDateInfo
  const [dateObj, setDateObj] = useState(selectedDateInfo)

  const [showDownloadSuccessModal, setShowDownloadSuccessModal] = useState(false)
  const [showDownloadInfoVisible, setShowDownloadInfoVisible] = useState(false)

  const insets = useSafeAreaInsets()

  const insetbottom = Platform.OS == 'android' ? insets.bottom : 0
  const insetTop = Platform.OS == 'android' ? insets.top : 0

  const isFocused = useIsFocused()
  useEffect(() => {
    if (isFocused) {
      // navigate to received txn screen
      setSelectedTabIndex(0)
    }
  }, [isFocused])

  useEffect(() => {
    if (toastMessage?.length > 0 && showDownloadInfoVisible) {
      setTimeout(() => {
        toastResetMessage()
        setShowDownloadInfoVisible(false)
      }, 5000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toastMessage, showDownloadInfoVisible])

  useEffect(() => {
    if (!!exportFileAPiData && exportFileApiState !== 'pending') {
      setDateRangeModalVisible(false)
      if (exportFileAPiData?.code === FILE_DOWNLOADED || exportFileAPiData?.code === DOWNLOAD_FAILED) {
        setShowDownloadSuccessModal(true)
        if (exportFileAPiData?.code === FILE_DOWNLOADED) {
          setTimeout(() => {
            handleClear()
          }, 1000)
        }
      } else {
        setShowDownloadInfoVisible(toastMessage?.length > 0)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportFileApiState])

  useEffect(() => {
    if (generateFileState !== 'pending') {
      setDateRangeModalVisible(false)
    }
  }, [generateFileState])

  const checkPermissionAndExport = async () => {
    logEvent('btn_press', 'open_export_payments')
    if (exportFileApiState !== 'pending') {
      hasPermissions().then((value) => {
        if (value) {
          setDateRangeModalVisible(true)
        } else {
          setMessage('Permissions not granted')
        }
      })
    }
  }

  const onGeneratePress = () => {
    logEvent('btn_press', 'Generate and Download')
    //  setShowDownloadReportsVisible(false)
    setDateRangeModalVisible(false)
    // setShowDownloadSuccessModal(false)
    if (!isEmpty(dateObj?.fromDate) && !isEmpty(dateObj.toDate) && !isEmpty(dateObj.dateLabel)) {
      if (selectedTabIndex === 1) {
        if (generateFileState !== 'pending') {
          generateSettlemFile('Excel', true)
        }
      } else {
        exportFile('Excel', getType[selectedTabIndex], exportStatementDateInfo)
      }
    }
  }
  const isExportEnabled = () => {
    if ((selectedTabIndex === 0 || selectedTabIndex === 2) && canExportTransationsReport) {
      return true
    }
    return false
  }

  const renderExportIcon = () => {
    if (!ENABLE_REPORT_DOWNLOADS_IN_MOBILE) {
      return null
    }
    const handlePress = () => {
      logEvent('btn_press', 'Reports')
      setShowDownloadReportsVisible(true)
    }
    return (
      <Box underlayColor={'TRANSPARENT'} testID="document" onPress={handlePress}>
        <SvgImage imageName={showDownloadInfoVisible ? 'documentWithDot' : 'document'} />
      </Box>
    )
  }

  const handleClear = () => {
    updateExportStatementDateInfo(selectedDateInfo)
    setDateObj(selectedDateInfo)
    setDateRangeModalVisible(false)
  }

  const updateDateRange = (date: any) => {
    updateExportStatementDateInfo(date)
    setDateObj(date)
  }

  const share = async (path: any) => {
    // setShowDownloadSuccessModal(false)
    try {
      const shareOptions = {
        url: `file://'${path}`,
      }
      await DeviceShare(shareOptions)
      // setShowDownloadSuccessModal(false)
    } catch (error) {
      console.log(error)
      setShowDownloadSuccessModal(false)
    }
  }

  const openFile = async () => {
    // setShowDownloadSuccessModal(false)
    if (exportFileAPiData?.code === 1 && !isEmpty(exportFileAPiData?.filepath)) {
      if (Platform.OS === 'ios') {
        FileViewer.open(exportFileAPiData?.filepath)
          .then(() => {
            // success
          })
          .catch((_err) => {
            console.log(_err)
            setShowDownloadSuccessModal(false)
          })
      } else {
        try {
          openFileOnDevice(exportFileAPiData?.filepath, setMessage)
        } catch (err) {
          console.log(err)
        }
      }
    } else {
      onGeneratePress()
    }
  }

  const h = Dimensions.get('screen').height
  return (
    <Box f={1} bg={'SECONDARY'}>
      <Box flexDirection={'row'} align={'center'} justify={'space-between'} ph={24} h={64} pv={20} zIndex={10}>
        <Text
          title={getString(selectedAppLanguage, 'payments')}
          fontFamily={'JioType-Bold'}
          fontSize={18}
          lineHeight={24}
          letterSpacing={-0.09}
          color={'WHITE'}
        />
        {renderExportIcon()}
      </Box>
      <ModBox ph={24} pt={8} pb={24}>
        <ReceivedTransactionStats fetchTxn={null} screenName={PAYMENTS} />
      </ModBox>
      <Box {...tabContainer}>
        {!showDownloadReportsVisible && isFocused && (
          <TopTabNavigator
            fetchTxnColumns={fetchTxnColumns}
            fetchRefunds={fetchRefunds}
            fetchTxn={fetchTxn}
            fetchStatsApi={fetchSettlementsApi}
            fetchTxnColumnsOnLoadMore={fetchTxnColumnsOnLoadMore}
            fetchRefundsOnLoadMore={fetchRefundsOnLoadMore}
            fetchTxnOnLoadMore={fetchTxnOnLoadMore}
            refundApiHandlers={refundApiHandlers}
            transactionApiHandlers={transactionApiHandlers}
            settlementApiHandler={[settlementApiHandler]}
            refundApiLoadMoreHandlers={refundApiLoadMoreHandlers}
            transactionApiLoadMoreHandlers={transactionApiLoadMoreHandlers}
            isFocused={isFocused}
            tabs={[
              { name: getString(selectedAppLanguage, 'received'), component: ReceivedTransactionNative },
              { name: getString(selectedAppLanguage, 'settled'), component: Settled },
              { name: getString(selectedAppLanguage, 'refunded'), component: RefundedTransactionNative },
            ]}
            onTabChange={(tabIndex: any) => {
              logEvent('payments_tab_change', tabIndex === 0 ? 'Received' : tabIndex === 1 ? 'Settled' : 'Refunded')
              setSelectedTabIndex(tabIndex)
            }}
          />
        )}
      </Box>
      <ModalDialogNew
        onBackPress={() => setDateRangeModalVisible(false)}
        animate={true}
        type="bottom"
        show={dateRangeModalVisible}
        backgroundColor={'TRANSPARENT'}>
        <Box borderTopLeftRadius={24} borderTopRightRadius={24} bg={'WHITE'}>
          <Box flexDirection={'row'} justify={'space-between'} pt={32} ph={24} pb={16}>
            <Box maxWidth={'80%'}>
              <Text
                title={getString(selectedAppLanguage, 'exportTxnStatement')}
                fontFamily={'JioType-Black'}
                color={Colors.BLACK_14 as ColorOptions}
                fontSize={24}
                lineHeight={32}
                letterSpacing={-0.09}
              />
            </Box>
            <Spacer direction={'horizontal'} size={24} />
            <IconButton
              id={'CLOSE'}
              color={Colors.BLACK_14 as ColorOptions}
              size={24}
              testID="close-date-range"
              onPress={handleClear}
            />
          </Box>
          <KeyboardAwareScrollView
            showsVerticalScrollIndicator={false}
            keyboardDismissMode="interactive"
            keyboardShouldPersistTaps="handled"
            scrollEnabled={true}
            enableAutomaticScroll={true}
            automaticallyAdjustKeyboardInsets={true}
            keyboardOpeningTime={Number.MAX_SAFE_INTEGER}
            enableResetScrollToCoords={false}
            extraHeight={120}
            enableOnAndroid={true}>
            <DateRangeSelector
              onDateRangeChange={updateDateRange}
              selectedDateInfo={exportStatementDateInfo}
              type={'EXPORT'}
              selectedFilteredData={{ selectedDateInfo: exportStatementDateInfo }}
            />
            <Box p={24} w={'100%'}>
              <Button
                disabled={
                  (!exportStatementDateInfo?.fromDate && !exportStatementDateInfo.toDate) ||
                  (exportStatementDateInfo?.dateLabel === 'Custom Range' &&
                    !exportStatementDateInfo?.fromDate &&
                    !exportStatementDateInfo?.toDate) ||
                  exportStatementDateInfo?.dateLabel === actionMenuStrings.infiniteScrollRange
                }
                isFull
                height={50}
                isRound
                testID="generate-file"
                onPress={onGeneratePress}
                type={'primary'}
                color={'PRIMARY'}
                underlayColor="PRIMARY"
                isLoading={
                  ((selectedTabIndex === 0 || selectedTabIndex === 2) && exportFileApiState === 'pending') ||
                  (selectedTabIndex === 1 && generateFileState === 'pending')
                }>
                <Text
                  title={getString(selectedAppLanguage, 'genetrateAndDownload')}
                  fontFamily={'JioType-Bold'}
                  lineHeight={24}
                  color={'WHITE'}
                />
              </Button>
            </Box>
          </KeyboardAwareScrollView>
        </Box>
      </ModalDialogNew>

      <ModalDialogNew animate={true} backgroundColor={'TRANSPARENT'} show={showDownloadSuccessModal} type={'bottom'}>
        <Box bg={'WHITE'} borderTopLeftRadius={24} borderTopRightRadius={24}>
          <DownloadFileModal
            status={exportFileAPiData?.code}
            onPress={() => openFile()}
            onShare={() => share(exportFileAPiData?.filepath)}
            close={() => setShowDownloadSuccessModal(false)}
          />
        </Box>
      </ModalDialogNew>

      <ModBox
        position={'absolute'}
        zIndex={10}
        w={48}
        h={48}
        borderRadius={24}
        bg={'PRIMARY'}
        shadowType={'shadowPrimary'}
        borderWidth={1}
        borderColor={'PRIMARY'}
        align={'center'}
        justify={'center'}
        bottom={24}
        right={24}
        show={isExportEnabled()}
        testID="download-file"
        onPress={checkPermissionAndExport}
        underlayColor={'PRIMARY'}>
        <SvgImage imageName={'downloadFile'} />
      </ModBox>
      {showDownloadInfoVisible && (
        <DownloadInfo
          hide={!showDownloadInfoVisible}
          infoPos={10}
          onDismiss={() => setShowDownloadInfoVisible(false)}
          message={toastMessage}
        />
      )}

      <ModalDialogNew
        show={showDownloadReportsVisible}
        type={'bottom'}
        backgroundColor={'TRANSPARENT'}
        animate={true}
        borderRadius={24}>
        <Box bg={'WHITE'} borderTopRightRadius={24} borderTopLeftRadius={24} pv={32}>
          <Box flexDirection={'row'} align={'flex-start'} justify={'space-between'} ph={24}>
            <Box maxWidth={'90%'} pr={20}>
              <Text
                title={'Transaction Statements'}
                fontFamily={'JioType-Black'}
                color={Colors.BLACK_14 as ColorOptions}
                fontSize={24}
                lineHeight={32}
                letterSpacing={-0.09}
              />
            </Box>
            <Box mt={5}>
              <IconButton
                id={'CLOSE'}
                color={Colors.BLACK_14 as ColorOptions}
                size={24}
                testID="close-modal"
                onPress={() => setShowDownloadReportsVisible(false)}
              />
            </Box>
          </Box>
          <Spacer direction={'vertical'} size={16} />
          <ModBox height={h - 200 - insetbottom - insetTop}>
            {showDownloadReportsVisible && <Downloads isSettlements={selectedTabIndex === 1} />}
          </ModBox>
        </Box>
      </ModalDialogNew>
    </Box>
  )
}
const tabContainer = {
  borderTopLeftRadius: 24,
  borderTopRightRadius: 24,
  bg: 'WHITE',
  f: 1,
  shadowColor: '#0000001F' as ColorOptions,
  shadowOffset: {
    width: 0,
    height: 5,
  },
  shadowOpacity: 0.16,
  shadowRadius: 16,
} as BoxProps
